import { useEffect, useState } from 'react'

/**
 * Re-renders the caller on a fixed interval so live countdowns advance.
 *
 * This replaces the `setInterval` the Vue `Giveaway` constructor started for
 * every instance it created — those were never cleared, so a session that
 * browsed a few pages ended up with dozens of timers writing to detached
 * objects. One timer per mounted countdown, cleaned up on unmount.
 */
export function useTicker(intervalMs = 1000, enabled = true): number {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (!enabled) return
    const id = window.setInterval(() => setTick((value) => value + 1), intervalMs)
    return () => window.clearInterval(id)
  }, [intervalMs, enabled])

  return tick
}
